/* eslint-disable radix */
import React from 'react'
import { ReactComponent as Gift } from '../../../../assets/icons/gift.svg'
import styled from 'styled-components'
import { bool, string, func } from 'prop-types'
import Button from '@taglivros/oef_componentes/build/components/button'
import Select from '@taglivros/oef_componentes/build/components/select'
import {
  ROUTE_BASEPATH,
  URLS
} from '../../../../constants'
import { URLS_APP } from '../../../../config'
import { navigate } from '@reach/router'
import moment from 'moment'

const RenovarAgoraWrapper = styled.div`
  background: ${( { isCuradoria } ) => ( isCuradoria ? '#F2FFFF' : '#FFF7EF' )};
  padding: 18px 18px 18px 33px;
  display: flex;
  flex-direction: column;
  margin-top: 10px;
  .message-span {
    font-family: "Noto Sans Display", sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    color: #1b2a68;
  }
  .normal-span {
    font-size: 12px;
    line-height: 16px;
    font-family: "Noto Sans Display", sans-serif;
    padding-top: 10px;
  }
  .svg-spans {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 19px;
  }
  button {
    width: 96%;
    margin-top: 20px;
  }
  .data {
    display: flex;
    align-items: center;
  }
  .data label {
    display: none;
  }
  .data select {
    width: 60px;
  }
`

const validDates = [
  {
    'codigo': '11',
    'value': '11',
    'visualizacao': '11'
  },
  {
    'codigo': '25',
    'value': '25',
    'visualizacao': '25'
  }
]

export const RenovarAgora = ( { setDays, isCuradoria, nextData, selectedDay } ) => {
  function findDefaultDay() {
    const defaultDay = selectedDay
      ? moment( selectedDay, 'YYYY-MM-DD' ).format( 'DD' )
      : '25'
    if ( defaultDay === '25' || defaultDay === '11' ) {
      return validDates.find( item => item.value === defaultDay )
    }
    return validDates.find( item => item.value === '11' )
  }

  function renderSelect() {
    return parseInt( moment().format( 'DD' ) ) <= 10
  }

  return (
    <RenovarAgoraWrapper
      id="renovar-agora"
      isCuradoria={ isCuradoria }
    >
      <div className="svg-spans">
        <div>
          <Gift />
        </div>

        <span className="message-span">
          A renovação automática da sua assinatura está programada para
          acontecer dia:
          <div className="data">
            {renderSelect() ? (
              <Select
                defaultOption={ findDefaultDay() }
                itens={ validDates }
                label=""
                onChange={ event => setDays( event.value ) }
                required={ true }
              />
            ) : (
              <span>{findDefaultDay().value}</span>
            )}

            <span>/{moment( nextData, 'M/YYYY' ).format( 'MM/YYYY' )}</span>
          </div>
        </span>
      </div>

      <div>
        <Button
          onClick={ () => navigate( `${ROUTE_BASEPATH}${URLS_APP.BASE_PATH ? '/' : ''}${isCuradoria ? 'curadoria': 'ineditos'}/${URLS.PLANO}/${URLS.RENOVAR_PLANO_ENTREGA}` ) }
          tema={ isCuradoria ? Button.BOTAO_CURADORIA : Button.BOTAO_INEDITOS }
        >
          Prefiro renovar agora
        </Button>
      </div>

      <div className="normal-span">
        <span>
          Caso você renove manualmente agora você não será cobrado novamente
        </span>
      </div>
    </RenovarAgoraWrapper>
  )
}

RenovarAgora.propTypes = {
  'isCuradoria': bool.isRequired,
  'nextData': string.isRequired,
  'selectedDay': string.isRequired,
  'setDays': func.isRequired
}
